
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaArrowRight, FaPlay } from 'react-icons/fa';
import './ChassisTransport.css';

import heroBg from '../../Assets/Services/ChassisTransport/Background.png';
import introImage from '../../Assets/Services/ChassisTransport/Ship.png'; // Reusing for now
import whyChooseImage from '../../Assets/Services/ChassisTransport/Truck.png'; // Reusing for now

const ChassisTransport = () => {

    // ScrollToTop component in App.js handles scrolling on route change

    const fadeInUp = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };

    return (
        <div className="chassis-transport">

            {/* Hero Section */}
            <div className="chassis-hero" style={{ backgroundImage: `url(${heroBg})` }}>
                <Container>
                    <motion.div
                        className="chassis-hero-content"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h1>Chassis Transport</h1>
                        <p>Secure and compliant transportation of truck, bus, and tractor chassis across India.</p>
                    </motion.div>
                </Container>
            </div>

            {/* Intro Section */}
            <section className="chassis-intro">
                <Container>
                    <Row>
                        <Col md={12}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <img src={introImage} alt="Chassis Transport" className="img-fluid" />
                            </motion.div>
                        </Col>
                        <Col md={12} className="mt-4">
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Truck Chassis Transport India</h2>
                                <p>
                                    Janta Roadways provides dedicated chassis transport solutions for leading OEMs and commercial vehicle manufacturers. Our
                                    specially designed carriers are equipped to handle truck, bus, and tractor chassis with complete safety and structural stability.
                                    With engineered loading mechanisms and trained operational teams, we ensure secure handling, route compliance, and timely
                                    delivery across Pan-India destinations.
                                    <br />
                                    Backed by strict CMVR adherence and SOP-driven execution, we deliver precision logistics tailored to manufacturer
                                    requirements.
                                </p>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Why Choose Section */}
            <section className="chassis-why-choose">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Why Choose Our Chassis Transport</h2>
                                <span className="subtitle">Engineered carriers. Controlled movement. Reliable delivery.</span>

                                <ul className="why-choose-list">
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Custom-built chassis carriers</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Secure locking & structural support systems</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Damage-free loading and unloading process</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> CMVR-compliant fleet operations</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> GPS-enabled live tracking</li>
                                </ul>
                            </motion.div>
                        </Col>
                        <Col md={6}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <img src={whyChooseImage} alt="Chassis Fleet" className="why-choose-image shadow-sm" />
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Process Framework */}
            <section className="chassis-process">
                <Container>
                    <Row className="align-items-center">
                        <Col md={7}>
                            <motion.div
                                className="video-placeholder shadow"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <div className="play-button">
                                    <FaPlay size={20} />
                                </div>
                            </motion.div>
                        </Col>
                        <Col md={5}>
                            <motion.div
                                className="process-content"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Our Chassis Transport Process</h2>
                                <div className="process-steps">
                                    <div className="process-step">Requirement Analysis</div>
                                    <div className="process-step">Carrier Planning & Allocation</div>
                                    <div className="process-step">Safe Loading & Securing</div>
                                    <div className="process-step">Execution & Monitoring</div>
                                    <div className="process-step">Delivery & Documentation</div>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default ChassisTransport;
